import React, { useEffect, useState } from "react";
import { auth, db } from "../services/firebase";
import { ref, get, onValue } from "firebase/database";
// At top of Dashboard.js
import { setPersistence, browserSessionPersistence } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { 
  FaHome, 
  FaChartBar, 
  FaEnvelope, 
  FaCog, 
  FaSignOutAlt, 
  FaSun, 
  FaMoon,
  FaRandom,
  FaCode,
  FaPlay,
  FaEye,
  FaUser,
  FaClipboard,
  FaUsers,
  FaTrophy,
  FaBook,
  FaCalendarAlt,
  FaClock,
  FaStar,
  FaArrowRight,
  FaPlus
} from "react-icons/fa";


// import TestMCQ from "../components/TestMCQ";
// import TestCoding from "../components/TestCoding";
import AdminUpload from "../components/AdminUpload";
import ViewResults from "../components/ViewResults";
import InvitePage from "./InvitePage";
import AdminPanel from "./AdminPanel";
import AdminVersionPanel from "../components/AdminVersionPanel";
import AdminCodingUpload from "../components/AdminCodingUpload";
import AdminCodeSnippetUpload from "../components/AdminCodeSnippetUpload";
import EditProfile from "../components/EditProfile";

import "./Dashboard.css";
import AdminTeacherApproval from "./AdminTeacherApproval";

function Dashboard({ user }) {
  const [view, setView] = useState("home");
  const [isAdmin, setIsAdmin] = useState(false);
  const [profile, setProfile] = useState(null);
  const [quizzes, setQuizzes] = useState({});
  // const [selectedQuiz, setSelectedQuiz] = useState(null);
  const [codingQuizzes, setCodingQuizzes] = useState({});
  const [codeSnippetQuizzes, setCodeSnippetQuizzes] = useState({});
  // const [selectedCodingQuiz, setSelectedCodingQuiz] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [mcqDisplayCount, setMcqDisplayCount] = useState(8);
  const [codingDisplayCount, setCodingDisplayCount] = useState(8);
  const [codeSnippetDisplayCount, setCodeSnippetDisplayCount] = useState(8);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");
  const [showInvitePopup, setShowInvitePopup] = useState(false);
const [inviteLink, setInviteLink] = useState("");



setPersistence(auth, browserSessionPersistence);


  const navigate = useNavigate();
  useEffect(() => {
    if (!user) return;

    const userRef = ref(db, `users/${user.uid}`);
    get(userRef).then((snapshot) => {
      if (snapshot.exists()) {
        setProfile(snapshot.val());
      }
    });

    const adminRef = ref(db, `admins/${user.uid}`);
    get(adminRef).then((snap) => {
      setIsAdmin(snap.exists());
    });

    const quizRef = ref(db, "quizzes/");
    onValue(quizRef, (snapshot) => {
      setQuizzes(snapshot.val() || {});
    });

    const codingRef = ref(db, "codingQuestions/");
    onValue(codingRef, (snapshot) => {
      setCodingQuizzes(snapshot.val() || {});
    });

    const codeSnippetRef = ref(db, "codeSnippetQuestions/");
    onValue(codeSnippetRef, (snapshot) => {
      setCodeSnippetQuizzes(snapshot.val() || {});
    });
  }, [user]);

  useEffect(() => {
    document.body.classList.toggle("dark", darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      localStorage.setItem("theme", newMode ? "dark" : "light");
      return newMode;
    });
  };

  // const logout = () => {
  //   auth.signOut();
  //   localStorage.removeItem("user");
  //   // Dispatch custom event to notify App.js about user change
  //   window.dispatchEvent(new Event('userChanged'));
  //   window.location.href = "/";
  // };

  const logout = async () => {
  await auth.signOut();
  window.location.replace("/");
};


  // const copyInviteLink = async () => {
  //   const inviter = profile?.username;
  //   const link = `${window.location.origin}/invite?from=${encodeURIComponent(inviter)}`;
  //   try {
  //     await navigator.clipboard.writeText(link);
  //     alert("✅ Invite link copied! Share it with your friends.");
  //   } catch (err) {
  //     alert("❌ Failed to copy invite link.");
  //   }
  // };

const openInvitePopup = () => {
  const inviter =
    profile?.username ||
    profile?.name ||
    user?.displayName ||
    "user";

  const link = `${window.location.origin}/invite?from=${encodeURIComponent(inviter)}`;

  setInviteLink(link);
  setShowInvitePopup(true);
};



 

  
  // Helper function to sort quizzes by date (newest first)
  const sortQuizzesByDate = (quizzesObj) => {
    return Object.entries(quizzesObj)
      .map(([id, quiz]) => ({ id, ...quiz }))
      .sort((a, b) => {
        const dateA = new Date(a.date || 0);
        const dateB = new Date(b.date || 0);
        return dateB - dateA; // Newest first
      });
  };

  const sortedMcqQuizzes = sortQuizzesByDate(quizzes);
  const sortedCodingQuizzes = sortQuizzesByDate(codingQuizzes);
  const sortedCodeSnippetQuizzes = sortQuizzesByDate(codeSnippetQuizzes);

  return (
    <div className={`dashboard-grid ${darkMode ? "dark-mode" : ""}`}>
      <div className="hamburger" onClick={() => setShowSidebar(!showSidebar)}>☰</div>

      <aside className={`sidebar ${showSidebar ? "show" : ""}`}>
        <div className="profile-box">
          <div className="avatar-wrapper">
            {profile?.avatar ? (
              <img src={profile.avatar} alt="Avatar" className="avatar-img" />
            ) : (
              <div className="avatar">{(profile?.name || "U")[0]}</div>
            )}
            <img
              src="https://img.icons8.com/?size=100&id=zqRKVWtC1VeY&format=png&color=000000"
              alt="Edit"
              className="edit-icon"
              onClick={() => setView("editProfile")}
              title="Edit Profile"
            />
          </div>

          <h3>{profile?.name || user.displayName || user.username || user.email}</h3>
          <span className="status-badge">Active</span>

          <button onClick={() => setView("results")}><FaChartBar /> Results</button>
          <button onClick={openInvitePopup}>
  <FaEnvelope /> Invite
</button>

          {isAdmin && <button onClick={() => setView("admin")}><FaCog /> Admin Panel</button>}
          <button onClick={logout}><FaSignOutAlt /> Logout</button>
          <button onClick={toggleDarkMode}>
            {darkMode ? <FaSun /> : <FaMoon />} {darkMode ? "Light Mode" : "Dark Mode"}
          </button>
        </div>

        <nav className="sidebar-nav">
          <button onClick={() => setView("home")}><FaHome /> Home</button>

          <button onClick={() => {
            const quizList = Object.entries(quizzes);
            if (quizList.length > 0) {
              const random = quizList[Math.floor(Math.random() * quizList.length)];
              // setSelectedQuiz({ ...random[1], id: random[0] });
              // setView("selectedQuiz");
              const randomId = random[0];
              navigate(`/test-mcq/${randomId}`, { target: "_blank" });
            } else {
              alert("No MCQ quizzes available.");
            }
            setShowSidebar(false);
          }}>
            <FaRandom /> Random MCQ
          </button>

          <button onClick={() => {
            const quizList = Object.entries(codingQuizzes);
            if (quizList.length > 0) {
              const random = quizList[Math.floor(Math.random() * quizList.length)];
              // setSelectedCodingQuiz({ ...random[1], id: random[0] });
              // setView("selectedCodingQuiz");
              const randomId = random[0];
              navigate(`/test-coding/${randomId}`, { target: "_blank" });
            } else {
              alert("No coding quizzes available.");
            }
            setShowSidebar(false);
          }}>
            <FaCode /> Random Coding
          </button>
        </nav>
      </aside>

      <main className="main-content">
        {view === "home" && (
          <>
            <div className="notification-bar">
              <p><FaUsers /> Welcome to BodhAI — Explore the latest tests</p>
            </div>

            {/* AI Generator Maintenance Notice Banner */}
            <div className="ai-busy-notice-banner">
              <div className="ai-notice-icon">🤖</div>
              <div className="ai-notice-content">
                <h4>AI Test Generator Maintenance Notice</h4>
                <p>
                  Our AI question generation server is currently experiencing high demand and under maintenance. 
                  Real-time AI test generation features are temporarily limited. 
                  Please attempt the pre-loaded MCQ and Coding practice sets below!
                </p>
              </div>
            </div>

            <section className="quiz-section">
              <h3><FaBook /> MCQ Quizzes</h3>
              <div className="quiz-list">
                {/* {Object.entries(quizzes).map(([id, quiz]) => (
                  <div className="quiz-card" key={id}>
                    <strong>{quiz.title || id}</strong> */}
                {sortedMcqQuizzes.slice(0, mcqDisplayCount).map((quiz) => (
                  <div className="quiz-card" key={quiz.id}>
                    <strong>{quiz.title || quiz.id}</strong>
                    <p><FaCalendarAlt /> {quiz.date}</p>
                    <p><FaClipboard /> {quiz.questions ? Object.keys(quiz.questions).length : 0} Questions</p>
                    {/* <button onClick={() => {
                      setSelectedQuiz({ ...quiz, id });
                      setView("selectedQuiz");
                    }}>
                      ▶️ Start
                    </button> */}
                    {/* <button onClick={() => navigate(`/test-mcq/${id}`, { target: "_blank"})}>
                      ▶️ Start
                    </button> */}
                    <button onClick={() => navigate(`/test-mcq/${quiz.id}`, { target: "_blank" })}>
                      <FaPlay /> Start
                    </button>


                  </div>
                ))}
              </div>
              {sortedMcqQuizzes.length > mcqDisplayCount && (
                <div className="view-more-container">
                  <button 
                    className="view-more-btn"
                    onClick={() => setMcqDisplayCount(prev => prev + 8)}
                  >
                    <FaEye /> View More MCQ Quizzes ({sortedMcqQuizzes.length - mcqDisplayCount} remaining)
                  </button>
                </div>
              )}
            </section>

            <section className="quiz-section">
              <h3><FaCode /> Coding Quizzes</h3>
              <div className="quiz-list">
                {/* {Object.entries(codingQuizzes).map(([id, quiz]) => (
                  <div className="quiz-card" key={id}>
                    <strong>{quiz.quizTitle || id}</strong> */}
                     {sortedCodingQuizzes.slice(0, codingDisplayCount).map((quiz) => (
                  <div className="quiz-card" key={quiz.id}>
                    <strong>{quiz.quizTitle || quiz.id}</strong>
                    <p><FaCalendarAlt /> {quiz.date}</p>
                    <p><FaCode /> {quiz.questions ? Object.keys(quiz.questions).length : 0} Questions</p>
                    {/* <button onClick={() => {
                      setSelectedCodingQuiz({ ...quiz, id });
                      setView("selectedCodingQuiz");
                    }}>
                      ▶️ Start
                    </button> */}
                    {/* <button onClick={() => navigate(`/test-coding/${id}`, { target: "_blank" })}>
                      ▶️ Start
                    </button> */}
                    <button onClick={() => navigate(`/test-coding/${quiz.id}`, { target: "_blank" })}>
                      <FaPlay /> Start
                    </button>


                  </div>
                ))}
              </div>
              {sortedCodingQuizzes.length > codingDisplayCount && (
                <div className="view-more-container">
                  <button 
                    className="view-more-btn"
                    onClick={() => setCodingDisplayCount(prev => prev + 8)}
                  >
                    <FaEye /> View More Coding Quizzes ({sortedCodingQuizzes.length - codingDisplayCount} remaining)
                  </button>
                </div>
                             )}
             </section>

             <section className="quiz-section">
               <h3><FaCode /> Code Snippet Quizzes</h3>
               <div className="quiz-list">
                 {sortedCodeSnippetQuizzes.slice(0, codeSnippetDisplayCount).map((quiz) => (
                   <div className="quiz-card" key={quiz.id}>
                     <strong>{quiz.quizTitle || quiz.id}</strong>
                     <p><FaCalendarAlt /> {quiz.date}</p>
                     <p><FaCode /> {quiz.questions ? Object.keys(quiz.questions).length : 0} Questions</p>
                     <button onClick={() => navigate(`/test-code-snippet/${quiz.id}`, { target: "_blank" })}>
                       <FaPlay /> Start
                     </button>
                   </div>
                 ))}
               </div>
               {sortedCodeSnippetQuizzes.length > codeSnippetDisplayCount && (
                 <div className="view-more-container">
                   <button 
                     className="view-more-btn"
                     onClick={() => setCodeSnippetDisplayCount(prev => prev + 8)}
                   >
                     <FaEye /> View More Code Snippet Quizzes ({sortedCodeSnippetQuizzes.length - codeSnippetDisplayCount} remaining)
                   </button>
                 </div>
               )}
             </section>
           </>
         )}

        {/* {view === "selectedQuiz" && selectedQuiz && (
          <TestMCQ user={user} quizData={selectedQuiz} />
        )} */}



        {/* {view === "selectedCodingQuiz" && selectedCodingQuiz && (
          <TestCoding user={user} quizData={selectedCodingQuiz} />
        )} */}

        {view === "results" && <ViewResults user={user} />}
        {view === "invite" && <InvitePage />}
        {view === "editProfile" && profile && (
          <EditProfile user={user} profile={profile} onDone={() => setView("home")} />
        )}
        {view === "admin" && isAdmin && (
          <>
            <AdminUpload user={user} />
            <AdminCodingUpload user={user} />
            <AdminCodeSnippetUpload user={user} />
            <AdminPanel currentUID={user.uid} />
            <AdminVersionPanel />
            <AdminTeacherApproval />
          </>
        )}
      </main>
      {showInvitePopup && (
  <div className="ref-overlay" onClick={() => setShowInvitePopup(false)}>
    <div className="ref-modal" onClick={(e) => e.stopPropagation()}>
      
      <button className="ref-close" onClick={() => setShowInvitePopup(false)}>
        ✕
      </button>

      {/* HERO */}
      <div className="ref-hero">
        <span className="ref-badge">🎁 EARN 50 CREDITS 🎁</span>
        <h2>Build together. Grow together</h2>
      </div>

      {/* LINK */}
      <div className="ref-link-box">
        <span className="ref-link">{inviteLink}</span>
        <button
          onClick={async () => {
            await navigator.clipboard.writeText(inviteLink);
          }}
        >
          Copy Link
        </button>
      </div>

      {/* INFO */}
      <div className="ref-cards">
        <div className="ref-card">
          <FaUsers />
          <p>Share your referral link</p>
        </div>

        <div className="ref-card">
          <FaStar />
          <p>They get extra 5 credits when they join</p>
        </div>

        <div className="ref-card">
          <FaTrophy />
          <p>You earn 50 credits on first subscription</p>
        </div>
      </div>

      {/* STATS */}
      <div className="ref-stats">
        <div>
          <h3>0</h3>
          <span>Referral credit earned</span>
        </div>
        <div>
          <h3>0</h3>
          <span>Total invitations</span>
        </div>
      </div>

      <a className="ref-terms" href="#">
        View Terms & Conditions ↗
      </a>

    </div>
  </div>
)}

    </div>
  );
}

export default Dashboard;
